import {useCallback, useState} from "react";

const useCustomModal = (initialState = false) => {
    const [isOpen, setIsOpen] = useState(initialState);
    const toggleModal = useCallback(() => setIsOpen((status) => !status), []);
    return [isOpen, toggleModal];
};

export default useCustomModal;
